import { httpGet } from 'utils/http';


;(function() {

    var loginEl = document.querySelector('._login');

    function focusLoginEl() {
        if (document.activeElement.tagName != 'INPUT') {
            loginEl.querySelector('.email').focus();
        }
    }

    function initLogoutPHP() {
        if (_logout) {
            httpGet('/?DROPSESSION=1');
        }
    }

    focusLoginEl();
    initLogoutPHP();

})();
